import React, { useEffect, useState } from 'react'
import profileBanner from '../../Assets/images/profile-bnr.webp'
import useMakeRequest from '../../utils/ApiHelper'
import { ApiConstants } from '../../constants/ApiConstants'
import Logo from '../../Assets/images/cms-logo.png'
import FrontLoader from '../layout/FrontLoader'
import { useParams } from 'react-router-dom'


function UserFaq() {
    const FaqList = useMakeRequest()
    const [data, setData] = useState([])
    const { id } = useParams()
    
    useEffect(() => {
        const payload = {
            "user_type": 2,
            lang_id:id
        }
        FaqList.makeRequest({ payload, url: ApiConstants?.Faqlist, toastStatus: false })
    }, [])
    useEffect(() => {
        if (FaqList?.status) {
            setData(FaqList?.data?.data)
        }
    }, [FaqList?.status])

    return (
        <>

            <main>
                <div className="container footer-space">
                <div className="pro-sugg-img" style={{textAlign:'center' , marginBottom:"14px"}} >   
                   <img src={Logo} alt="product" />
             </div>
                    <div className="accordion faq-accordian" id="faqExample">
                        {data.length > 0 && data.map((res: any, i) => (
                            <div className="accordion-item" key={i}>
                                <h2 className="accordion-header" id={`heading${i}`}>
                                    <button
                                        className="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#collapse${i}`}
                                        aria-expanded="true"
                                        aria-controls={`collapse${i}`}
                                    >
                                        {res?.faqs_details?.question}
                                    </button>
                                </h2>
                                <div
                                    id={`collapse${i}`}
                                    className={`accordion-collapse collapse ${i === 0 ? 'show' : ''}`}
                                    aria-labelledby={`heading${i}`}
                                    data-bs-parent="#faqExample"
                                >
                                    <div className="accordion-body">
                                        {res?.faqs_details?.answer}
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
            </main>

        </>
    )
}

export default UserFaq